import './header_2026';
import Footer from './footer';
import returnToTop from './returnToTop';
import baidu from './baidu';
import { contractInit } from './contract';
import $ from 'jquery';

function initTrialScroll() {
    document.querySelectorAll('.toUse, .user-message a.toUse').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            const contactAnchor = document.getElementById('contact');
            const applyContainer = document.querySelector('.apply-container');
            if (contactAnchor) {
                contactAnchor.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            if (applyContainer) {
                document.body.scrollTop = document.documentElement.scrollTop = applyContainer.offsetTop;
            }
        });
    });
}

function initTabs(rootSelector) {
    const tabRoot = document.querySelector(rootSelector);
    if (!tabRoot || tabRoot.dataset.pd2026TabsInit === 'true') {
        return;
    }

    tabRoot.dataset.pd2026TabsInit = 'true';

    const tabButtons = tabRoot.querySelectorAll('.pd2026-tabs__btn');
    const tabPanels = tabRoot.querySelectorAll('.pd2026-tabs__panel');

    tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const tabIndex = button.getAttribute('data-tab');
            tabButtons.forEach(function (item) {
                item.classList.toggle('is-active', item === button);
            });
            tabPanels.forEach(function (panel) {
                panel.classList.toggle('is-active', panel.getAttribute('data-panel') === tabIndex);
            });
        });
    });
}

function bootProduct2026Features() {
    initTrialScroll();
    initTabs('[data-pd2026-tabs="annotation"]');
    initTabs('[data-pd2026-tabs="cineon"]');
    initTabs('[data-pd2026-tabs="claw"]');
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProduct2026Features);
} else {
    bootProduct2026Features();
}

export function registerProductPage(productName, productType) {
    const pageNode = document.body;
    const dataPageName = pageNode && pageNode.getAttribute('data-lead-page');
    const dataProductId = pageNode && pageNode.getAttribute('data-lead-product-id');
    const subnavLabel = document.querySelector('.ds-subnav__label');
    const resolvedName = (dataPageName && dataPageName.trim())
        || (subnavLabel && subnavLabel.textContent && subnavLabel.textContent.trim())
        || productName
        || 'TalkingData官网';
    const resolvedType = (dataProductId && dataProductId.trim())
        || productType
        || undefined;
    contractInit('in', resolvedName, resolvedType);
}

export default {
    initTrialScroll,
    initTabs,
    registerProductPage,
};
